import React, { useEffect, useState } from "react";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CustomTab, {
  TabContainer,
} from "../../../components/tabs/customTabs";
import LetterTemplates from "./letterTemplate";
import ReceiptTemplates from "./receiptTemplate";
import IdentityCardTemplates from "./identityCardTemplate";
// import MarkSheetTemplates from "./markSheetTemplate";
// import CertificateTemplates from "./certificateTemplate";
import { useNavigate, useSearchParams } from "react-router-dom";
import BirthdayTemplates from "./birthdayTemplate";

const ManageTemplates = () => {
  const [search, setSearch] = useState();

  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    if (tabFromUrl !== null && tabFromUrl !== undefined) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams]);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`?tab=${tabId}`);
  };

  const items = [
    { label: "Manage Templates" },
  ];

  const tabs = [
    {
      id: "tab1",
      label: "Letter",
      content: (
        <div className="overflow-x-auto flex flex-col gap-2">
          <LetterTemplates showAllCards={true} />
        </div>
      ),
    },
    {
      id: "tab2",
      label: "Receipt",
      content: (
        <div className="flex flex-col gap-2 overflow-auto">
          <ReceiptTemplates />
        </div>
      ),
    },
    {
      id: "tab3",
      label: "Identity Card",
      content: (
        <div className="flex flex-col gap-2 overflow-auto">
          <IdentityCardTemplates />
        </div>
      ),
    },
    
    // {
    //   id: "tab4",
    //   label: "Certificate",
    //   content: (
    //     <div className="flex flex-col gap-2 overflow-auto">
    //       <CertificateTemplates />
    //     </div>
    //   ),
    // },
    {
      id: "tab4",
      label: "Birthday",
      content: (
        <div className="flex flex-col gap-2 overflow-auto">
          <BirthdayTemplates />
        </div>
      ),
    },
  ];

  return (
    <div className={"flex flex-col"}>
      <PageTableHeader breadcrumbs={items} isSearch={false} isFilter={false} />

      <div className="flex flex-row gap-2 overflow-x-auto max-w-full">
        <div className="flex flex-col bg-white p-4 w-full">
          <div className="flex flex-row gap-4 ">
            <div className="flex flex-row items-center gap-4 text-theme font-bold">
              <h2 className="text-theme font-bold text-sm">Templates</h2>
            </div>
            <div className="overflow-x-auto max-w-full">
              <CustomTab
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
                overflow={true}
              />
            </div>
          </div>
          <TabContainer tabs={tabs} activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
};
export default ManageTemplates;
